import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const SUPPORTED_LANGUAGES = ['tr', 'nl', 'fr', 'ar'] as const;

/**
 * Handles redirects from old ?lang= query parameter URLs to new path-based URLs
 * e.g., /treatments?lang=nl -> /nl/treatments
 */
export const LegacyLanguageRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (/^\/en(?=\/|$)/.test(location.pathname)) {
      navigate((location.pathname.replace(/^\/en(?=\/|$)/, '') || '/') + location.search + location.hash, { replace: true });
      return;
    }
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get('lang');

    if (langParam && SUPPORTED_LANGUAGES.includes(langParam as typeof SUPPORTED_LANGUAGES[number])) {
      searchParams.delete('lang');
      const remainingParams = searchParams.toString();

      const currentPath = location.pathname;
      const newPath =
        currentPath === '/'
          ? `/${langParam}/`
          : `/${langParam}${currentPath}`;
      const newUrl = `${newPath}${remainingParams ? `?${remainingParams}` : ''}${location.hash}`;

      // 301-equivalent client-side replace so the old URL isn't kept in history.
      navigate(newUrl, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default LegacyLanguageRedirect;
